/**
 * Predefined store / link sources used by the per-game Links feature.
 *
 * Used by the MDB Edit Game dialog (Links editor) and the Browse page
 * (rendering link buttons under the Amazon affiliate block). Adding a new
 * store: append here, the UI picks it up automatically.
 *
 * `color` drives the hover accent. Keep colors readable on the dark theme.
 */
export const STORE_OPTIONS = [
  { value: "amazon",       label: "Amazon",            color: "#FF9900" },
  { value: "ebay",         label: "eBay",              color: "#E53238" },
  { value: "gog",          label: "GOG.com",           color: "#86328A" },
  { value: "steam",        label: "Steam",             color: "#66C0F4" },
  { value: "epic",         label: "Epic Games Store",  color: "#2A2A2A" },
  { value: "playstation",  label: "PlayStation Store", color: "#003791" },
  { value: "xbox",         label: "Xbox / Microsoft",  color: "#107C10" },
  { value: "nintendo",     label: "Nintendo eShop",    color: "#E60012" },
  { value: "humble",       label: "Humble Bundle",     color: "#CC2929" },
  { value: "fanatical",    label: "Fanatical",         color: "#FF4655" },
  { value: "greenman",     label: "Green Man Gaming",  color: "#88C425" },
  { value: "itch",         label: "itch.io",           color: "#FA5C5C" },
  { value: "playasia",     label: "Play-Asia",         color: "#E10E1F" },
  { value: "pricecharting",label: "PriceCharting",     color: "#10A37F" },
  { value: "wiki",         label: "Wiki / Reference",  color: "#A78BFA" },
  { value: "guide",        label: "Guide / Walkthrough", color: "#22D3EE" },
  { value: "other",        label: "Other",             color: "#94A3B8" },
];

export const STORE_BY_VALUE = STORE_OPTIONS.reduce((acc, s) => {
  acc[s.value] = s;
  return acc;
}, {});

export const DEFAULT_STORE = "other";
